import React from 'react';

const Footer = () => {
    return (
        <div>
            <footer className="footer">
                <div className="row">
                    <div className="col-lg-12">
                        <p className="footer-txt">Ingenious Construction</p>
                    <p className="footer-txt">&#169;All Rights Reserved 2025</p> 
                    </div>                    
                </div>
            </footer>
        </div>
    );
};


export default Footer;